import * as types from "./../types";


const initialState = {
    error: null,
    photoUploadStage: {
      loading: false,
      isSubmitedSuccess: false
    },
    hsToken:null
}

const TakePhotoReducer = (state = initialState, action) => {
    switch (action.type) {
      case types.SET_TAKE_PHOTO_ERROR:
        return {
          ...state,
          error: action.payload
        };
      case types.RESET_TAKE_PHOTO_ERROR:
        return {
          ...state,
          error: null
        }
      case types.SET_PHOTO_MATCH_LOADING:
        return {
          ...state,
          photoUploadStage: action.payload
        }
        case types.SAVE_HSTOKEN:
          return {
            ...state,
          hsToken: action.payload
          }
      default:
        return state;
    }
};
export default TakePhotoReducer;